var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18403_21081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0C11.2912 0 7.2497 1.39852 4.44793 4.19793C1.64852 6.9997 0.25 11.0412 0.25 16C0.25 20.9588 1.64852 25.0003 4.44793 27.8021C7.2497 30.6015 11.2912 32 16.25 32C21.2088 32 25.2503 30.6015 28.0521 27.8021C30.8515 25.0003 32.25 20.9588 32.25 16C32.25 11.0412 30.8515 6.9997 28.0521 4.19793C25.2503 1.39852 21.2088 0 16.25 0Z",
    fill: "#EBEDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 19.5H10.25L9.25 11.5L13.25 14.5L16.25 10L19.25 14.5L23.25 11.5L22.25 19.5Z",
    stroke: "#181E26",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 22.5H21.75",
    stroke: "#181E26",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18403_21081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingIcon);
export default __webpack_public_path__ + "static/media/ranking-icon.1ea6b08f72cb8936a7826952d972967d.svg";
export { ForwardRef as ReactComponent };